(() => {
  const existingSchools = Array.isArray(window.ACSambaSchools) ? window.ACSambaSchools : [];
  const evaluationOverrides = new Set([
    'Arame de Ricardo',
    'Coroado de Jacarepaguá',
    'Difícil é o Nome',
  ]);

  const additionalSchools = [
    {
      name: 'Gato de Bonsucesso',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo215.jpg',
      lat: -22.854643,
      lng: -43.242872,
      founded: '16/02/1999',
      address: 'Rua São Jorge, s/n, Nova Holanda, Rio de Janeiro – RJ, 21042-680',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+S%C3%A3o+Jorge%2C+Nova+Holanda%2C+Rio+de+Janeiro%2C+RJ%2C+21042-680',
      division: 'Grupo de Avaliação',
      colours: 'Blue and white',
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/gato-de-bonsucesso/',
    },
    {
      name: 'Império Ricardense',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo335.jpg',
      lat: -22.8393562,
      lng: -43.4001665,
      founded: '01/01/2015',
      address: 'Rua Japoara, 100, Ricardo de Albuquerque, Rio de Janeiro – RJ',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+Japoara%2C+100%2C+Ricardo+de+Albuquerque%2C+Rio+de+Janeiro%2C+RJ',
      division: 'Grupo de Avaliação',
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/imperio-ricardense/',
    },
    {
      name: 'Mocidade Independente de Inhaúma',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo199.jpg',
      lat: -22.86927,
      lng: -43.281021,
      founded: '07/05/1995',
      address: 'Praça Muiraquitã, s/n, Inhaúma, Rio de Janeiro – RJ',
      maps: 'https://www.google.com/maps/search/?api=1&query=Pra%C3%A7a+Muiraquit%C3%A3%2C+Inha%C3%BAma%2C+Rio+de+Janeiro%2C+RJ',
      division: 'Grupo de Avaliação',
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/mocidade-independente-de-inhauma/',
    },
    {
      name: 'Mocidade Unida da Cidade de Deus',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo200.jpg',
      lat: -22.9500517,
      lng: -43.3588533,
      founded: '29/03/1970',
      address: 'Rua Edgard Werneck, 1607, Cidade de Deus, Rio de Janeiro – RJ, 22763-011',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+Edgard+Werneck%2C+1607%2C+Cidade+de+Deus%2C+Rio+de+Janeiro%2C+RJ%2C+22763-011',
      division: 'Grupo de Avaliação',
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/mocidade-unida-da-cidade-de-deus/',
    },
    {
      name: 'Unidos de Manguinhos',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo211.jpg',
      lat: -22.8801794,
      lng: -43.253236,
      founded: '23/04/1964',
      address: 'Avenida dos Democráticos, 32, Manguinhos, Rio de Janeiro – RJ',
      maps: 'https://www.google.com/maps/search/?api=1&query=Avenida+dos+Democr%C3%A1ticos%2C+32%2C+Manguinhos%2C+Rio+de+Janeiro%2C+RJ',
      division: 'Grupo de Avaliação',
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/unidos-de-manguinhos/',
    },
    {
      name: 'Acadêmicos da Barra da Tijuca',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo239.jpg',
      lat: -22.997810963075,
      lng: -43.318502233978,
      address: 'Estrada do Itanhangá, 1681, Itanhangá, Rio de Janeiro – RJ, 22753-005',
      maps: 'https://www.google.com/maps/search/?api=1&query=Estrada+do+Itanhang%C3%A1%2C+1681%2C+Rio+de+Janeiro%2C+RJ%2C+22753-005',
      division: 'Inativas ou Extintas',
      status: 'Extinct',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/academicos-da-barra-da-tijuca/',
    },
    {
      name: 'Acadêmicos do Cachambi',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo181.jpg',
      lat: -22.890362005164,
      lng: -43.267743020909,
      address: 'Rua Miguel Angelo, 620, Cachambi, Rio de Janeiro – RJ, 20785-225',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+Miguel+Angelo%2C+620%2C+Cachambi%2C+Rio+de+Janeiro%2C+RJ%2C+20785-225',
      division: 'Inativas ou Extintas',
      status: 'Inactive',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/academicos-do-cachambi/',
    },
    {
      name: 'Canários das Laranjeiras',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo188.jpg',
      lat: -22.937251503084,
      lng: -43.179110932713,
      address: 'Rua Paulo VI, 62, Flamengo, Rio de Janeiro – RJ, 22230-080',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+Paulo+VI%2C+62%2C+Flamengo%2C+Rio+de+Janeiro%2C+RJ%2C+22230-080',
      division: 'Inativas ou Extintas',
      status: 'Extinct',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/canarios-das-laranjeiras/',
    },
    {
      name: 'Corações Unidos do Amarelinho',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo246.jpg',
      lat: -22.824694795311,
      lng: -43.334432157277,
      address: 'Avenida Brasil, 18476, Irajá, Rio de Janeiro – RJ, 21530-000',
      maps: 'https://www.google.com/maps/search/?api=1&query=Avenida+Brasil%2C+18476%2C+Iraj%C3%A1%2C+Rio+de+Janeiro%2C+RJ%2C+21530-000',
      division: 'Inativas ou Extintas',
      status: 'Succeeded by another school; extinct since 01/12/2017',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/coracoes-unidos-do-amarelinho/',
    },
    {
      name: 'Tupy de Brás de Pina',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo154.jpg',
      lat: -22.835656005347,
      lng: -43.290451021535,
      address: 'Rua Guaíba, 133, Brás de Pina, Rio de Janeiro – RJ, 21215-070',
      maps: 'https://www.google.com/maps/search/?api=1&query=Rua+Gua%C3%ADba%2C+133%2C+Br%C3%A1s+de+Pina%2C+Rio+de+Janeiro%2C+RJ%2C+21215-070',
      division: 'Inativas ou Extintas',
      status: 'Succeeded by another school; extinct since 20/07/2018',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/tupy-de-bras-de-pina/',
    },
    {
      name: 'União de Vaz Lobo',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo96.jpg',
      lat: -22.861390878848,
      lng: -43.330104967267,
      address: 'Avenida Ministro Edgard Romero, 756, Vaz Lobo, Rio de Janeiro – RJ, 21360-200',
      maps: 'https://www.google.com/maps/search/?api=1&query=Avenida+Ministro+Edgard+Romero%2C+756%2C+Rio+de+Janeiro%2C+RJ%2C+21360-200',
      division: 'Inativas ou Extintas',
      status: 'Extinct',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/uniao-de-vaz-lobo/',
    },
    {
      name: 'Unidos do Uraiti',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo208.jpg',
      lat: -22.847758006699,
      lng: -43.341363958708,
      address: 'Estrada do Barro Vermelho, 1080, Colégio, Rio de Janeiro – RJ, 21540-501',
      maps: 'https://www.google.com/maps/search/?api=1&query=Estrada+do+Barro+Vermelho%2C+1080%2C+Col%C3%A9gio%2C+Rio+de+Janeiro%2C+RJ%2C+21540-501',
      division: 'Inativas ou Extintas',
      status: 'Extinct',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/unidos-do-uraiti/',
    },
    {
      name: 'Unidos da Zona Sul',
      logo: 'https://www.galeriadosamba.com.br/images/logos/logo217.jpg',
      lat: -22.961121151671,
      lng: -43.175236481789,
      address: 'Avenida Princesa Isabel, 440, Copacabana, Rio de Janeiro – RJ, 22011-010',
      maps: 'https://www.google.com/maps/search/?api=1&query=Avenida+Princesa+Isabel%2C+440%2C+Copacabana%2C+Rio+de+Janeiro%2C+RJ%2C+22011-010',
      division: 'Inativas ou Extintas',
      status: 'Inactive',
      historicalLocation: true,
      website: 'Galeria do Samba profile',
      websiteUrl: 'https://galeriadosamba.com.br/escolas-de-samba/unidos-da-zona-sul/',
    },
  ];

  window.ACSambaSchools = existingSchools
    .map((school) => evaluationOverrides.has(school.name)
      ? { ...school, division: 'Grupo de Avaliação' }
      : school)
    .concat(additionalSchools);
})();
